import { Add, LibraryAdd } from '@mui/icons-material';
import { CustomConfirmDialog } from '../../../components/CustomConfirmDialog';

export const AddCategoryDialog = (props: {
    open: boolean;
    onClose: () => void;
    onAddFromPresets: () => void;
    onAddManually: () => void;
    dialogTitle: string;
}) => {

  return (
    <CustomConfirmDialog
      open={props.open}
      handleClose={props.onClose}
      dialogTitle={props.dialogTitle}
      icon1={{
        title: 'general.text.add_custom_category',
        subTitle: 'general.text.add_custom_category_subtitle',
        action: props.onAddManually,
        icon: <Add />,
      }}
      icon2={{
        title: 'general.text.add_from_presets',
        subTitle: 'general.text.add_from_presets_subtitle',
        action: props.onAddFromPresets,
        icon: <LibraryAdd />,
      }}
    />
  );

};
